import { Badge } from "./Badge";

export const MaxOrderQuantityBadge = ({
  maxQuantity,
  fullSize = true,
}: {
  maxQuantity: number;
  fullSize?: boolean;
}) => {
  return (
    <Badge
      className={
        "items-center gap-1 border border-zinc-100 bg-zinc-100 px-1 px-2 py-1 text-sm font-semibold"
      }
      icon={"SPEEDOMETER"}
      iconSize={0.7}
    >
      {fullSize ? `Max order qty: ${maxQuantity}` : maxQuantity}
    </Badge>
  );
};
